import React from 'react';
import { ModernButton } from '../ui/ModernButton';

export function DefaultTemplateConfirmModal({ templateName, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-slate-800 dark:text-slate-200 p-6 rounded-2xl shadow-2xl max-w-md w-full m-4 transform transition-all duration-300">
        <div className="flex items-center gap-3 mb-4">
          <div className="shrink-0">
            <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Vorlage für formale Fragen löschen?</h2>
        </div>
        <p className="text-slate-600 dark:text-slate-300 mb-6">
          Die Vorlage für formale Fragen <strong>"{templateName}"</strong> wird unwiderruflich gelöscht.
          <br /><br />
          Möchten Sie fortfahren?
        </p>
        <div className="flex gap-3">
          <ModernButton onClick={onCancel} variant="secondary" size="lg" className="flex-1">
            Abbrechen
          </ModernButton>
          <ModernButton onClick={onConfirm} variant="danger" size="lg" className="flex-1">
            Löschen
          </ModernButton>
        </div>
      </div>
    </div>
  );
}
